import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RightWhiteArrow from "../rightwhitearrow";
import LeftWhiteArrow from "../leftwhitearrow";
import { Button } from "antd";
import { Component } from "react";
const win = window;
export default class BllueButton extends Component {
    constructor() {
        super(...arguments);
        this.handleSubmit = (event) => {
            var _a;
            event.preventDefault();
            var myForm = this.props.form;
            if (!myForm) {
                this.props.onClick();
                return;
            }
            (_a = myForm === null || myForm === void 0 ? void 0 : myForm.validateFields()) === null || _a === void 0 ? void 0 : _a.then((values) => {
                if (!values.errorFields || values.errorFields.length === 0) {
                    this.props.onClick(myForm);
                }
            }).catch((errorInfo) => {
                console.log(errorInfo);
            });
        };
    }
    render() {
        return (_jsx(Button, Object.assign({ className: this.props.buttonClass, shape: "round", disabled: this.props.disabled, type: "primary", htmlType: "button", onClick: this.handleSubmit }, { children: _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("div", Object.assign({ className: "mx-4" }, { children: this.props.text }), void 0), _jsx("div", { className: "col" }, void 0), _jsx("div", Object.assign({ className: "mx-4" }, { children: _jsx("span", { children: win["lang"] === "ar" ? (_jsx(LeftWhiteArrow, {}, void 0)) : (_jsx(RightWhiteArrow, {}, void 0)) }, void 0) }), void 0)] }), void 0) }), void 0));
    }
}
